module.exports = __webpack_public_path__ + "static/media/img-msg-talent-manager@3x.0a29b460.png";